import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { memo } from 'react';
import { FaRegTrashAlt, FaCog, FaFilter } from 'react-icons/fa';
import Button from '../../elements/Button';
import ToggleButton from '../../elements/ToggleButton';
import ToolTip from '../../elements/ToolTip/ToolTip';
const styles = css `
  display: flex;
  flex-direction: row;
  border-bottom: 0.55px solid rgb(240, 240, 240);
  padding: 2px 5px;

  .left-container {
    display: flex;
    flex-direction: row;
    flex: 1;
  }
  .counter-label {
    margin: 0;
    text-align: right;
    line-height: 22px;
    padding: 0px 10px;
    white-space: nowrap;
  }
`;
function DefaultPanelHeader({ counter, onDelete = () => null, deleteToolTip = 'Delete', onFilter = () => null, filterToolTip = '', filterIsActive = false, counterFiltered = 0, children, onSettingClick = () => null, showSettingButton = false, canDelete = true, style = {}, className = '', }) {
    return (_jsxs("div", { css: styles, ...{ style, className }, children: [_jsxs("div", { className: "left-container", children: [canDelete && (_jsx(ToolTip, { title: deleteToolTip, popupPlacement: "right", children: _jsx(Button, { type: "button", fill: "clear", backgroundColor: { base: 'white', hover: 'white' }, color: { base: 'black', hover: 'red' }, onClick: onDelete, disabled: counter === 0, children: _jsx(FaRegTrashAlt, {}) }) })), filterToolTip ? (_jsx(ToggleButton, { popupTitle: filterToolTip, popupPlacement: "right", onClick: onFilter, defaultValue: filterIsActive, children: _jsx(FaFilter, { style: { pointerEvents: 'none', fontSize: '12px' } }) })) : null, children] }), counter !== undefined && (_jsxs("p", { className: "counter-label", children: ["[", ' ', filterIsActive && counterFiltered !== undefined
                        ? `${counterFiltered}/${counter}`
                        : counter, ' ', "]"] })), showSettingButton && (_jsx(ToolTip, { title: "preferences", popupPlacement: "left", children: _jsx("button", { type: "button", onClick: onSettingClick, children: _jsx(FaCog, {}) }) }))] }));
}
export default memo(DefaultPanelHeader);
